import React, { useState } from 'react';
import { Heading, Icons, PropertyGroup } from '../../components';

import css from './ListingPage.module.css';

const SectionMultiEnumMaybe = props => {
  const { heading, options, selectedOptions, key, showUnselectedOptions = true } = props;
  const hasContent = showUnselectedOptions || selectedOptions?.length > 0;
  if (!heading || !options || !hasContent) {
    return null;
  }
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = index => {
    setOpenIndex(openIndex === index ? null : index); // close if same, open if new
  };

  return (
    <section className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading} onClick={() => toggle(key)}>
        {heading} <Icons name={openIndex === key ? 'minus' : 'plus'} />
      </Heading>
      {openIndex === key && (
        <PropertyGroup
          id="ListingPage.amenities"
          options={options}
          selectedOptions={selectedOptions}
          twoColumns={options.length > 5}
          showUnselectedOptions={showUnselectedOptions}
        />
      )}
    </section>
  );
};

export default SectionMultiEnumMaybe;
